import {
  CreateUserEntity,
  IAdminSetting,
  QueryParamStaff,
  UserEntity,
} from '@/interfaces';
import { QueryKeyType } from '@/types';
import { AxiosResponse } from 'axios';
import { QueryFunctionContext } from '@tanstack/react-query';
import APIService from './base.service';

const basePath = '/users';
export default class UserService {
  static async getProfile() {
    return (await APIService.get<UserEntity>('/auth/me')).data;
  }

  static getAdminSettings(): Promise<AxiosResponse> {
    return APIService.get('/admin-setting');
  }

  static async updateAdminSettings(
    payload: IAdminSetting,
  ): Promise<AxiosResponse> {
    return APIService.patch(`/admin-setting`, payload);
  }

  static getUsers({
    queryKey: [_, params],
  }: QueryFunctionContext<
    QueryKeyType<string, QueryParamStaff>
  >): Promise<AxiosResponse> {
    return APIService.get(basePath, { params });
  }

  static createUser(payload: CreateUserEntity): Promise<AxiosResponse> {
    return APIService.post(basePath, payload);
  }

  static assignRole(payload: {
    id: string;
    roles: number[];
  }): Promise<AxiosResponse> {
    const { id, roles } = payload;
    return APIService.patch('/users/' + id, { roles });
  }

  static deleteUser(id: number | string): Promise<AxiosResponse> {
    return APIService.delete(basePath + `/${id}`);
  }
}
